<template>
    <pulse-loader v-if="loading" />
    <v-app v-else-if="setup && users && users.length" id="inspire">
      <v-app-bar
        v-if="displayHeader && !$vuetify.breakpoint.mobile && !$dav.isTotem"
        :color="setup && setup.theme && setup.theme.light && setup.theme.light.secondary ? 'secondary' : 'primary'"
        dark
        class="app-bar-prime"
        fixed
        app
        clipped-right
        height="64px"
      >
        <v-app-bar-nav-icon v-if="ssoRoute !== homeRoute">
          <v-btn icon :title="$vuetify.lang.t('$vuetify.pages.home')" @click="moveFrameToHome">
            <v-icon> home </v-icon>
          </v-btn>
        </v-app-bar-nav-icon>

        <!-- Title Page -->
        <v-toolbar-title data-app>
          <v-img v-if="setup" :src="setup.picture" width="248" height="36" contain alt="Doutor ao Vivo" />
        </v-toolbar-title>

        <v-spacer />

        <dav-chat-bubble></dav-chat-bubble>

        <v-badge
          v-if="setup && setup.settings && setup.settings.message_module_enabled"
          right
          color="error"
          :content="count_unread_messages"
          :value="count_unread_messages"
          offset-x="25"
          offset-y="25"
          class="mr-2"
        >
          <v-btn id="page__messages" icon @click.stop="moveFrameToMessage()">
            <v-icon size="30">notifications</v-icon>
          </v-btn>
        </v-badge>

        <v-menu offset-y left :disabled="loading">
          <template #activator="{ on }">
            <v-btn color="blue lighten-2" fab small v-on="on">
              <dav-avatar v-if="users[select]" :source-size="36" :img-source="avatarPicture" />
            </v-btn>
          </template>
          <v-list v-if="unselectedUsers && unselectedUsers.length">
            <v-list-item>
              <v-list-item-title>{{ userSelected.name }}</v-list-item-title>
              <v-list-item-action>
                <v-btn icon>
                  <dav-avatar :source-size="36" :img-source="avatarPicture" />
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-list-item-group>
              <v-list-item @click="selectUser = true">
                <v-list-item-icon>
                  <v-icon>mdi-account-convert</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="$vuetify.lang.t('$vuetify.message.change_user')" />
                </v-list-item-content>
              </v-list-item>

              <v-list-item @click="editProfile">
                <v-list-item-icon>
                  <v-icon>mdi-account</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    v-text="`${$vuetify.lang.t('$vuetify.message.my_profile')} (${users[select].name})`"
                  />
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="validateButtonRegisterDependent()" @click="moveFrameToRegisterDependent">
                <v-list-item-icon>
                  <v-icon>mdi-account-plus</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="$vuetify.lang.t('$vuetify.label.register_dependent')" />
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="dialog = true">
                <v-list-item-icon>
                  <v-icon>logout</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="$vuetify.lang.t('$vuetify.message.sign_out')" />
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </v-app-bar>

      <v-main v-if="!dialogLogout" class="d-flex">
        <iframe
          v-if="users[select]"
          ref="iframe"
          :src="iframeUrl()"
          width="100%"
          height="100%" 
          :class="{ 'iframe-mobile-fixed': $vuetify.breakpoint.mobile }"
          style="border: 0;"
          allow="microphone; camera; encrypted-media; display-capture;"
          sandbox="allow-modals allow-same-origin allow-scripts allow-forms allow-popups"
          title="_"
        ></iframe>
        <pulse-loader v-else></pulse-loader>
      </v-main>

      <v-dialog v-model="dialogLogout" persistent width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title> Sessão encerrada </v-card-title>
          <v-card-text> Sua sessão excedeu o tempo limite </v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="primary" text @click="logout()"> Ok </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="selectUser" max-width="500px">
        <v-card>
          <v-card-title>
            {{ $vuetify.lang.t('$vuetify.label.select_user') }}
          </v-card-title>
          <v-card-text>
            <v-autocomplete
              v-model="selectionUser"
              :items="listUsers"
              item-value="id"
              item-text="name"
              :label="$vuetify.lang.t('$vuetify.label.select_user')"
            />
          </v-card-text>
          <v-card-actions style="display: flex; justify-content: space-between">
            <v-btn
              depressed
              style="text-transform: none;"
              @click="selectUser = false"
            >
              {{ $vuetify.lang.t('$vuetify.btn.cancel') }}
            </v-btn>
            <v-btn
              depressed
              color="primary"
              style="text-transform: none;"
              :disabled="selectionUser === null ? true : false"
              @click="saveSelectionUser"
            >
              {{ $vuetify.lang.t('$vuetify.label.select') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog" max-width="290">
        <v-card>
          <v-card-title class="text-h5"> {{ $vuetify.lang.t('$vuetify.message.sign_out') }} </v-card-title>

          <v-card-text> {{ $vuetify.lang.t('$vuetify.message.confirm_sign_out') }}</v-card-text>

          <v-card-actions>
            <v-spacer />

            <v-btn id="buttom_logout_yes" color="primary" @click="logout">
              {{ $vuetify.lang.t('$vuetify.btn.yes') }}
            </v-btn>

            <v-btn id="buttom_logout_no" color="primary" @click="dialog = false">
              {{ $vuetify.lang.t('$vuetify.btn.no') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-app>
  </div>
</template>
<script>
import PulseLoader from '../../../components/PulseLoader';
import { CommonSecurity, Fetcher } from '@primeit/components-vue';
import { Config } from '@dav/security-component-spa';
import ChatBubble from '@/components/chat-bubble.component.vue';

export default {
  tag: 'common-mso',
  components: {
    'dav-chat-bubble': ChatBubble,
    PulseLoader,
  },
  props: {
    children: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      pageLoaded: false,
      dialogLogout: false,
      displayHeader: true,
      userLogged: null,
      select: 0,
      dialog: false,
      loading: false,
      mini: false,
      parent_id: null,
      count_unread_messages: null,
      users: [],
      unread_amount: null,
      iframeLoaded: false,
      selectionUser: null,
      selectUser: false,
      ssoRoute: undefined,
      avatarPicture: ''
    };
  },
  computed: {
    setup() {
      return this.$store.getters['credential/SETUP'];
    },
    settings() {
      return this.$store.getters['company/GET_SETTINGS'];
    },
    host() {
      return window.location.host;
    },
    currentUser() {
      return this.$store.getters['credential/CURRENT_USER'];
    },
    childrenPso() {
      return this.$store.getters['user/USER_CHILDREN_PSO'];
    },
    unselectedUsers() {
      return this.users && this.users.length > 0
        ? this.users.filter((usr) => usr.id !== this.users[this.select].id)
        : null;
    },
    userSelected() {
      return this.users[this.select];
    },
    listUsers() {
      const users = [];

      for (const [index, item] of this.users.entries()) {
        users.push({
          id: index,
          name: item.name,
        });
      }

      return users;
    },
    person() {
      return this.$store.getters['patient/GET_ONE'];
    },
    homeRoute() {
      return '/';
    },
  },
  watch: {
    unread_amount(unread) {
      if (!unread || unread < 1) {
        this.count_unread_messages = 0;
      } else if (unread > 99) {
        this.count_unread_messages = '+99';
      }
      this.count_unread_messages = unread;
    },
    async childrenPso(childrenResponse) {
      if (childrenResponse && childrenResponse.length) {
        for (const child of childrenResponse) {
          try {
            const fetch = await Fetcher(`${process.env.VUE_APP_SERVICES_ENDPOINT_BASE_PERSON}/${child.id}`);

            if (fetch.ok) {
              const json = await fetch.json();

              const childProp = this.children.find((ch) => ch.id === child.id);
              this.users.push({
                id: child.id,
                pso: child.pso,
                name: childProp ? childProp.name : '',
                picture: childProp.picture ? this.getAvatar(childProp.picture) : undefined,
                mail: json.mail,
                parent_access_clinical_data: json.parent_access_clinical_data,
              });
            }
          } catch (e) {
            //
          }
        }
      }
    },
    select() {
      this.pageLoaded = false;
    },
  },
  created() {
    const vm = this;
    this.loading = true;

    window.addEventListener('message', (event) => {
      const data = event.data;

      if (data?.event) {
        switch (data.event) {
          case 'display_footer_and_header':
            vm.displayHeader = true;
            break;

          case 'hide_footer_and_header':
            vm.displayHeader = false;
            break;

          case 'RELOAD_EMERGENCY_FRAME':
            vm.moveFrameToEmergency();
            break;

          case 'update_unread_message_count':
            vm.unread_amount = data.detail.unread;
            break;

          case 'pso_session_end':
            if (this.select === 0) {
              vm.$root.$emit('mso_failed', null);
            } else {
              vm.select = 0;
            }
            break;

          case 'PATIENT_DISMISSED_BY_PROFESSIONAL':
            vm.service.dismissPatient();
            break;

          case 'sso_navigate':
            vm.ssoRoute = data.to;
            break;

          case 'update_picture':
            this.avatarPicture = data.picture;
            break;

          case 'chosen_user':
            vm.moveFrameToEmergencyInTotem(data.chosenUser);
        }
      }
    });

    const companyId = this.setup.companyId;
    this.$store.dispatch('company/FETCH_SETTINGS', companyId);
  },
  beforeDestroy() {
    window.sessionStorage.removeItem('original_pso');
  },
  async mounted() {
    try {
      this.userLogged = await CommonSecurity.getUser();
      if (this.userLogged) {
        const usernameRaw = this.userLogged.getAttribute('cognito:username');
        const username = usernameRaw.includes('@') ? usernameRaw.split('@')[1] : usernameRaw;
        await this.$store.dispatch('patient/FETCH_ONE', username);

        let pso = window.sessionStorage.getItem('original_pso');

        if (!pso) {
          await this.$store.dispatch('user/FETCH_USER_PSO');
          const mainUser = await this.$store.getters['user/USER_PSO'];
          if (!mainUser.pso) {
            throw new Error('Unable to get parent PSO');
          } else {
            pso = mainUser.pso;
          }
        }

        this.parent_id = username;

        try {
          const fetch = await Fetcher(`${process.env.VUE_APP_SERVICES_ENDPOINT_BASE_PERSON}/${this.parent_id}`);

          if (fetch.ok) {
            const json = await fetch.json();

            this.users.push({
              id: this.parent_id,
              pso,
              name: this.userLogged.getAttribute('name'),
              picture: this.userLogged.getAttribute('picture')
                ? this.getAvatar(this.userLogged.getAttribute('picture'))
                : undefined,
              mail: json.mail,
              parent_access_clinical_data: json.parent_access_clinical_data,
              isParent: true,
            });
          }
        } catch (e) {
          //
        }
      }
      this.$store.dispatch('user/FETCH_USER_CHILDREN_PSO');
    } catch (error) {
      this.$root.$emit('mso_failed', error);
    }
    this.loading = false;

    window.addEventListener('message', (e) => {
      const message = e.data;

      if (message.event === 'change_user') {
        this.selectUser = true;
      }

      if (message.loaded) {
        this.pageLoaded = true;
      }
    });
  },
  methods: {
    editProfile() {
      this.$refs.iframe.src = `//${this.host}/pso/${this.users[this.select].pso}?header=off&mso=on&profile=on`;
    },
    saveSelectionUser() {
      if (this.selectionUser !== null) {
        this.select = this.selectionUser;
      }

      this.selectionUser = null;
      this.selectUser = false;
    },
    iframeUrl() {
      let url = `//${this.host}/pso/${this.users[this.select].pso}`;
      
        //alterar o nome da url
      if(this.$dav.isTotem) {
        url += '/choosendependent';
      }

      if (this.isUserParent() && this.isRightAccessToEmergency()) {
        url += '/emergency?start=PERSON_WAITING_ROOM&mso=on&header=off';
        if (this.$route.query.group) {
          url += `&group=${this.$route.query.group}`;
        }
      } 
      else {
        url += '?mso=on&header=off';
        if (this.$route.query.group) delete this.$route.query.group;
        if (this.$route.query.start) delete this.$route.query.start;
      }
      return url;
    },
    isRightAccessToEmergency() {
      return this.$route.path.includes('/emergency/person') && this.$route.query.start === 'PERSON_WAITING_ROOM';
    },
    isUserParent() {
      return this.users[this.select].id === this.parent_id;
    },
    moveFrameToHome() {
      this.$refs.iframe.src = `//${this.host}/pso/${this.users[this.select].pso}?header=off&mso=on`;
    },
    moveFrameToEmergency() {
      this.$refs.iframe.src = `//${this.host}/pso/${this.users[this.select].pso}/emergency?header=off&mso=on`;
    },
    moveFrameToMessage() {
      this.$refs.iframe.src = `//${this.host}/pso/${this.users[this.select].pso}/message?header=off&mso=on`;
    },
    moveFrameToRegisterDependent() {
      this.$refs.iframe.src = `//${this.host}/pso/${this.users[this.select].pso}/registerdependent?header=off&mso=on`;
    },
    getAvatar(picture) {
      return `${process.env.VUE_APP_MEDIA_SERVER_BASE}/${picture}?ts=${Date.now()}`;
    },
    signOutIcon() {
      this.dialog = true;
    },
    listenEvents() {
      const vm = this;
      vm.$root.$on('show-dialog', function (options) {
        vm.showDialog();
      });
    },
    logout() {
      this.$store.dispatch('credential/LOGOUT');
    },
    pageName(label) {
      return this.$vuetify.lang.t('$vuetify.pages.' + label);
    },
    showDialog() {
      this.dialogLogout = true;
    },
    getGreet() {
      const today = new Date();
      const hour = today.getHours();

      if (hour >= 0 && hour <= 12) {
        return this.$vuetify.lang.t('$vuetify.label.goodMorning');
      }
      if (hour > 12 && hour < 18) {
        return this.$vuetify.lang.t('$vuetify.label.goodAfternoon');
      }
      if (hour >= 18 && hour <= 24) {
        return this.$vuetify.lang.t('$vuetify.label.goodEvening');
      }
    },
    validateButtonRegisterDependent() {
      const role = this.currentUser?.signInUserSession.idToken.payload['custom:roles'];
      const plan = this.settings?.subscription_plans?.find(
        (plan) => plan.integration_id === this.person?.plan_id
      );
      const allowRegisterDependents = this.isUserParent()
        && (plan?.allow_register_dependent_user || this.setup.settings?.allow_holder_register_dependents);

      let show = false;
      if (role === 'P' && allowRegisterDependents) {
        show = true;
      }

      return show;
    },
  },
};
</script>
<style lang="stylus" scoped>
.page-wrapper {
    min-height: calc(100vh - 64px - 50px - 0px);
}
.powered-by {
    float: right;
    margin-left: auto;
    font-size: x-small;
    font-weight: 100;
    word-spacing: 2px;
}
.iframe-mobile-fixed {
  position: fixed; 
} 
</style>
